import { fetchHome } from "./api";
import { homeQuery, type ResourceCache } from "./resourceCache";

/** Both consumers can refresh in either effect order. Deduplicate the wire
 * request by cache epoch, independently of each component's refresh counter. */
export function loadHome(cache: ResourceCache, search: string) {
  const query = homeQuery(search);
  return cache.load(`home-request${query}`, () => fetchHome(query), cache.version());
}
